import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonHeader, IonContent } from '@ionic/react';

import { OccupiedRoomDetailsModal } from './Modal_DetailData_OccupiedRoom';
import { OccupiedRoomDetailsModal_multiple } from './Modal_DetailData_OccupiedRoom_multiple';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { format, compareAsc } from 'date-fns';

//import '../css/hotelCss.css';
//import '../../../../css/qavaApp.css';
import '../../../css/layout.css';

export function ViewOccupiedRoomsModal (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    //let [showInvoiceModal, setViewInvoiceModal] = useState(false);
    let [showOccupiedRoomDetailsModal, setUpdateOccupiedRoomDetailsModal] = useState(false);
    let [showOccupiedRoomDetailsModal_multiple, setUpdateOccupiedRoomDetailsModal_multiple] = useState(false);

    let [viewInventoryOccupiedRooms, setViewInventoryOccupiedRooms] = useState([]);
    let [roomID, setRoomID] = useState(null);
    let [roomSalePrice, setRoomSalePrice] = useState(null);
    let [checkInDateActual, setCheckInDateActual] = useState(null);
    let [merchantInvoiceID, setMerchantInvoiceID] = useState(null);

    useEffect(() => {

        if(props.openModal == true)
        {
            /*
            let formData = new FormData();
            formData.append('Tracker', 74102);
            formData.append('user', acctID);
            formData.append('xStartDateRange', props.startDate.toISOString().substr(0, 10));
            formData.append('xEndDateRange', props.endDate.toISOString().substr(0, 10));
        
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74102',
                    user: acctID,
                    xStartDateRange: authenticatedMerchent_context.startDate,
                    xEndDateRange: authenticatedMerchent_context.endDate,
                    sessionID: sessionID,
    
                }),
            }
        
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
        
                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setViewInventoryOccupiedRooms((prevOccupiedRooms) => {
                        return prevOccupiedRooms.concat({

                            roomGuestFirstName: cols[0],
                            roomGuestLastName: cols[1],
                            roomGuestPhoneNumber: cols[2],
                            roomGuestPrice: parseFloat(cols[3]).toFixed(2),
                            //roomGuestCheckOutDateBooked: new Date(cols[4]).toISOString().substr(0, 10),
                            roomGuestCheckOutDateBooked: format(new Date(cols[4]), 'E') + ", " + format(new Date(cols[4]), 'MM/dd'),
                            roomGuestCheckInDateActual: format(new Date(cols[5]), 'E') + ", " + format(new Date(cols[5]), 'MM/dd'),
                            merchantInvoiceID: cols[6],
                            totalOriginalAmt: parseFloat(cols[7]).toFixed(2),
                            amtRemaining: parseFloat(cols[8]).toFixed(2),
                            roomGuestInvoiceAttachment: cols[9],
                            room_id_multiple: cols[10],
                            roomID: cols[11],
                            roomType: cols[12],
                            roomDescription: cols[13],
                            roomPartNum: cols[14],
                            roomPhoneNumber: cols[15],
                            address: cols[16],
                            city: cols[17],
                            country: cols[18],
                            roomSalePrice: parseFloat(cols[19]).toFixed(2),
                            attachment: cols[20],

                        })
                    });
                } 
            })
        }

    }, [props.openModal]);

    /*function updateViewAttachmentModal(event) {

    
        if(event[0])
        {
            this.setState(() => ({
    
                viewAttachment_InvoiceModal: event[0],
                roomGuestInvoiceAttachment: event[1],
                checkInRoomID: event[2],
                checkInSalesPrice: event[3],
    
            }));        
        }
        else
        {
                this.setState(() => ({
                viewAttachment_InvoiceModal: event,
                roomGuestInvoiceAttachment: null,
                checkInRoomID: null,
                checkInSalesPrice: null,
    
            })); 
        }
    }*/

    /*function updateOccupiedRoomDetailsModal(event) {

    
        if(event[0])
        {
            this.setState(() => ({
                showOccupiedRoomDetailsModal: event[0],
                checkInRoomID: event[1],
                checkInSalesPrice: event[2],
                checkInMemberID: event[3],
    
            }));        
    
            this.getOccupiedRoomDetailData(event[1]);
        }
        else
        {
            this.setState(() => ({
                showOccupiedRoomDetailsModal: event,
                checkInRoomID: null,
                checkInSalesPrice: null,
                checkInMemberID: null,
                viewInventoryOccupiedRoomDetailData: [],
            })); 
        }
    }*/

    function roomDetailModalHandler(event) {

        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        //setCheckInDateActual(event[3]);
        setMerchantInvoiceID(event[3]);
        setUpdateOccupiedRoomDetailsModal(event[0]);

    }

    function roomDetailModalHandler_multiple(event) {

        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        //setCheckInDateActual(event[3]);
        setMerchantInvoiceID(event[3]);
        setUpdateOccupiedRoomDetailsModal_multiple(event[0]);

    }

    const getAmtClass = (total, remaining) => {
        const t = parseFloat(total ?? 0);
        const r = parseFloat(remaining ?? 0);
        const EPS = 0.000001;
      
        if (Math.abs(r) < EPS && Math.abs(t) > EPS) return "paid";          // green
        if (Math.abs(t - r) < EPS) return "unpaid";    // red (no payment yet)
        return "partial";                               // yellow (some balance left)
      };

    function closeModalHandler() {

        setViewInventoryOccupiedRooms([]);
        props.closeModal();
    }
 
    return (

        <React.Fragment>
            {props.openModal == true ?
            (
            <IonModal isOpen={ props.openModal }>


                    <IonHeader style={{color: 'black'}}>
                        <IonText> Rooms Occupied </IonText>
                    </IonHeader>

                    <IonContent className='grid_content'>
                        <IonGrid>
                            <IonRow >
                                    <IonCol size='1'>Rm ID</IonCol>
                                    {/*<IonCol className='gridResultColumns'>Room Type</IonCol>*/}
                                    {/*<IonCol className='gridResultColumns'>Room Phone</IonCol>*/}
                                    <IonCol size='3'>Guest Name</IonCol>
                                    <IonCol size='3'>Total/Balance</IonCol> 
                                    <IonCol size='3'>Ckeck In-Out</IonCol>                                                                               
                                    <IonCol size='2'>Action</IonCol>
                            </IonRow>
                            {viewInventoryOccupiedRooms.map((detailData) =>   {

                                    const amtClass = getAmtClass(detailData.totalOriginalAmt, detailData.amtRemaining);

                                return (
                                    <IonRow key={detailData.roomID}>
                                        {detailData.room_id_multiple == 'NO' && <IonCol size='1'>{detailData.roomID}</IonCol>}
                                        {detailData.room_id_multiple != 'NO' && <IonCol size='1'>{detailData.room_id_multiple}</IonCol>}
                                        {/*<IonCol className='gridResultColumns'>{detailData.roomType}</IonCol>*/}
                                        {/*<IonCol className='gridResultColumns'>{detailData.roomPhoneNumber}</IonCol>*/}
                                        <IonCol size='3'>{detailData.roomGuestFirstName +" "+ detailData.roomGuestLastName}</IonCol>
                                        <IonCol size='3' className={`amountCol ${amtClass}`}>{detailData.totalOriginalAmt +" / "+ detailData.amtRemaining}</IonCol>
                                        <IonCol size='3' style={{fontSize: 'small'}}>{detailData.roomGuestCheckInDateActual +" to "+ detailData.roomGuestCheckOutDateBooked}</IonCol>
                                        <IonCol size='2'>
                                            {/*<IonButton onClick={() => roomDetailModalHandler([true, detailData.roomID, detailData.roomSalePrice, detailData.roomGuestCheckInDateActual])}> Details </IonButton>*/}
                                            {detailData.room_id_multiple == 'NO' && <IonButton onClick={() => roomDetailModalHandler([true, detailData.roomID, detailData.roomSalePrice, detailData.merchantInvoiceID])}> Details </IonButton>}
                                            {detailData.room_id_multiple != 'NO' && <IonButton onClick={() => roomDetailModalHandler_multiple([true, detailData.room_id_multiple, detailData.roomSalePrice, detailData.merchantInvoiceID])}> M_Details </IonButton>}
                                        </IonCol>
                                    </IonRow>
                                )
                            }
                            )}
                        </IonGrid>
                    </IonContent>

                {showOccupiedRoomDetailsModal == true && <OccupiedRoomDetailsModal openModal={ showOccupiedRoomDetailsModal } closeModal={() => setUpdateOccupiedRoomDetailsModal()} closeModal_updateComplete={() => closeModalHandler()} data={{
                    status: '',
                    roomID: roomID, 
                    roomSalePrice: roomSalePrice,
                    merchantInvoiceID: merchantInvoiceID,
                                        }}></OccupiedRoomDetailsModal>}

                {showOccupiedRoomDetailsModal_multiple == true && <OccupiedRoomDetailsModal_multiple openModal={ showOccupiedRoomDetailsModal_multiple } closeModal={() => setUpdateOccupiedRoomDetailsModal_multiple()} closeModal_updateComplete={() => closeModalHandler()} data={{
                    status: '',
                    roomID: roomID, 
                    roomSalePrice: roomSalePrice,
                    merchantInvoiceID: merchantInvoiceID,
                                        }}></OccupiedRoomDetailsModal_multiple>}

                    <IonButton className='button_closeModal_center' onClick={() => closeModalHandler()}> Close </IonButton>
            </IonModal>
            ) : null }
        </React.Fragment>

    )
}